import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProjectFeatureService {
  constructor(private api: ApiService) {}

  getAllFeatures(data: any): Observable<any> {
    return this.api.post(environment.getAllFeatures, data);
  }

  createFeature(data: any): Observable<any> {
    return this.api.post(environment.createFeature, data);
  }

  updateFeature(data: any): Observable<any> {
    return this.api.post(environment.updateFeature, data);
  }

  deleteFeature(data: any): Observable<any> {
    return this.api.post(environment.deleteFeature, data);
  }

  getFeatureById(data: any): Observable<any> {
    return this.api.post(environment.getFeatureById, data);
  }
}
